import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText} from '@mui/material';
import SurveyForm from '../components/SurveyForm'; // Import your survey form component
import { app } from '../components/Firebase';
import Button from "@mui/material/Button"
import Copyright from '../components/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import { Hidden } from '@mui/material';
import { appCheck } from "../App";
import { getToken  } from "firebase/app-check";
import Box from '@mui/material/Box';

function SurveyPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const [isLoading, setIsLoading] = useState(true);
  const [accessGranted, setAccessGranted] = useState(false);
  const [surveyData, setSurveyData] = useState(null);
  const [surveyTitle, setSurveyTitle] = useState(null);
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const processSurveyTakerURL = `/processSurveyTaker`;
  const handleSurveySubissionURL = `/handleSurveySubmission`;
  const [open, setOpen] = useState(true);
  // Function to handle user acceptance
   const handleAccept = () => {
     setOpen(false);
   };
   useEffect(() => {
    const fetchSurveyData = async () => {
      try {
        // Get a valid App Check token
        const appCheckTokenResponse = await getToken(appCheck, false);
  
        // Ensure we have a valid token before proceeding
        if (!appCheckTokenResponse?.token) {
          console.error("App Check token retrieval failed.");
          return;
        }
  
        // Make the fetch request after retrieving the App Check token
        const response = await fetch(processSurveyTakerURL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`, // Send the token in the Authorization header
            "X-Firebase-AppCheck": appCheckTokenResponse.token
          },
        });
  
        const data = await response.json();
  
        if (data.status === "success") {
          setAccessGranted(true);
  
          // Remove the 0: null entry if it exists
          if (data.data[0] === null) {
            delete data.data[0];
          }
  
          setSurveyData(data.data);
          setSurveyTitle(data.surveyId);
        }
      } catch (error) {
        console.error("Error fetching survey data:", error);
        setErrorDialogOpen(true);
      } finally {
        setIsLoading(false);
      }
    };
  
    if (token) {
      fetchSurveyData(); // Call the async function
    }
  }, [token]);
  

  const handleSubmit = async (event, responses) => {
    event.preventDefault(); // Prevent default form submission behavior
  
    // Find the index of the first response that is null or an empty string
    const firstUnansweredIndex = Object.values(responses).findIndex(
      (response) => response === null || response === ""
    );
  
    // Check if all questions have been answered
    if (firstUnansweredIndex !== -1) {
      alert(`Please answer question ${firstUnansweredIndex + 1} before submitting the survey.`);
      return;
    }
  
    setIsSubmitting(true);
  
    try {
      // Get a valid App Check token
      const appCheckTokenResponse = await getToken(appCheck, false);
      
      // Ensure we have a valid App Check token
      if (!appCheckTokenResponse?.token) {
        console.error("App Check token retrieval failed.");
        setIsSubmitting(false); // Reset submission state
        return;
      }
  
      // Prepare the data to be sent to the server
      const data = {
        token: token,
        answers: responses
      };
  
      // Trigger the Firebase function to handle survey submission
      const response = await fetch(handleSurveySubissionURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`, // Send the token in the Authorization header
          "X-Firebase-AppCheck": appCheckTokenResponse.token
        },
        body: JSON.stringify(data), // Send the token and answers in the body
      });
  
      if (response.status === 200) {
        // Handle successful submission
        setSubmissionStatus("success");
      } else if (response.status === 401) {
        setSubmissionStatus("canceled");
      } else {
        // Handle error
        setSubmissionStatus("error");
        setErrorDialogOpen(true);
      }
    } catch (error) {
      console.error("Error submitting survey:", error);
      setSubmissionStatus("error");
      setErrorDialogOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  

  
  const handleClose = () => {
    setErrorDialogOpen(false);
  };


  if (submissionStatus === 'success') {
    return <p>  <br/> <br/> Thank you for your submission! <br/> <br/> Your response has been recorded and will be sent to the requester. </p>;
  }
  else if (submissionStatus === 'canceled') {
    return <p>Your survey was canceled by the requester.</p>;
  }
  else if (isLoading) {
    return           <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh', // full viewport height
    }}
  >
    <Box  style={{ maxWidth: "8%", maxHeight: "8%" }}>
      <CircularProgress color="success" m={10} style={{
        zIndex: 9999,
      }}/>
    </Box>
  </Box>;
  }
  else if (!accessGranted && !isLoading) {
    return <p>Access denied.</p>;
  }
 

  return (
    <>
    <Dialog
      open={open}
      disableEscapeKeyDown // Prevent closing with the "Escape" key
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          setOpen(false);
        }
      }} // Prevent clicking outside the modal to close it
    >
      <DialogTitle>Informed Consent</DialogTitle>
      <DialogContent>
        <p>
        Venture Evaluations has been contracted to conduct a pre-employment psychological assessment as part of the hiring process for the company you are applying to (hereafter referred to as "the hiring company"). The purpose of this assessment is to evaluate psychological traits that may be relevant to the position you are applying for.
        <br/>
The assessment includes multiple-choice items which will be used to assess your standing on various psychological traits.
<br/>
Participation in this assessment is voluntary. You have the right to decline or withdraw from the process at any time. However, please note that declining to participate will result in your test result being reported as incomplete.
<br/>
The information collected during this assessment is confidential. We do not determine how the hiring company uses these results in their decision-making process.
<br/>
The final report generated from this assessment will be provided exclusively to the hiring company. Venture Evaluations does not provide copies of the report or raw data to candidates.
<br/>
Venture Evaluations does not make hiring decisions for our clients. The hiring company may use assessment results in their decision-making process.
<br/>
<h4>Acknowledgment and Consent</h4>
        </p>

By clicking the “Accept” button below, you acknowledge that you have read and understood this informed consent document. You agree to participate in the psychological assessment process voluntarily and understand its purpose and procedures.

        <p>

        </p>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleAccept}>
          Accept
        </Button>
      </DialogActions>
    </Dialog>
      {submissionStatus !== 'success' && submissionStatus !== 'canceled' && <SurveyForm surveyData={surveyData} surveyId={surveyTitle} onSubmit={handleSubmit} />}
      <Hidden xsUp={!isSubmitting}>
        <Box
          style={{
            position: "fixed", // Ensures it's fixed within the viewport
            top: 0,
            left: 0,
            width: "100vw", // Full width of viewport
            height: "100vh", // Full height of viewport
            display: "flex", // Enables flexbox centering
            justifyContent: "center", // Centers horizontally
            alignItems: "center", // Centers vertically
            zIndex: 9999, // Ensures it's above other elements
            backgroundColor: "rgba(255, 255, 255, 0.7)", // Optional semi-transparent background
          }}
        >
          <CircularProgress
            color="success"
            style={{
              width: "6%",
              height: "6%",
            }}
          />
        </Box>
      </Hidden>
      <Dialog open={errorDialogOpen} onClose={handleClose}>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please try again later.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Copyright sx={{ mt: 5 }} />
    </>
  );
}
export default SurveyPage;